import "./SelectPaymentGateway.css";

const SelectPaymentGateway = ({ form_pay, setform_pay, setGoSteps }) => {
  const select_pay = (type) => {
    setform_pay({
      ...form_pay,
      pasarela: type,
    });

    setGoSteps(2);
  };

  return (
    <div className="payment-container">
      <h2 className="payment-title">Pasarela de pago</h2>

      {form_pay.url_openpay !== null ? (
        <a
          href={form_pay.url_openpay}
          target="_blank"
          rel="noopener noreferrer"
          className="payment-openpay"
        >
          <img
            src="https://www.openpay.co/_ipx/_/img/header/openpay-color.svg"
            alt="Openpay"
          />
        </a>
      ) : (
        <div className="type-payment-card">
          {/* PSE */}
          <button
            type="button"
            className="type-payment-option payment-option-pse"
            onClick={() => select_pay("mercado_pago")}
          >
            <span className="payment-radio" />

            <img
              className="payment-logo payment-logo-pse"
              src="/images/pasarela/pse.png"
              alt="PSE pagos Elite Vacances"
            />

            <span className="payment-description">
              Pagos seguros
              <br />
              en línea
            </span>
          </button>

          {/* Mercado Pago */}
          <button
            type="button"
            className="type-payment-option payment-option-mercado"
            onClick={() => select_pay("mercado_pago")}
          >
            <span className="payment-radio" />

            <img
              className="payment-logo payment-logo-mercado"
              src="/images/pasarela/logo-mercado-pago.svg"
              alt="Mercado Pago pagos Elite Vacances"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default SelectPaymentGateway;
